import { TOGGLE_SUBNAV } from '../Actiontype';

export const toggleSubNav = () => ({
  type: TOGGLE_SUBNAV,
});
